<template>
    <nav class="relative z-0 inline-flex -space-x-px" >
        <div @click="dec" class="cursor-pointer relative inline-flex text-gray-700 items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50">
            <IconMinusSmSolid class="w-5 h-5"></IconMinusSmSolid>
          
            
        </div>
        <div :class="disabled?'text-gray-500': 'text-gray-700'" class="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50">
            {{ value }}
        </div>
        <div @click="inc" :class="disabled?'text-gray-500': 'text-gray-700 cursor-pointer'" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50">
            <IconPlusSmSolid class="w-5 h-5"></IconPlusSmSolid>
        </div>
    </nav>
</template>

<script>
import IconMinusOutline from "../../icons/outline/IconMinusOutline";
import IconMinusSmSolid from "../../icons/solid/IconMinusSmSolid";
import IconPlusSmSolid from "../../icons/solid/IconPlusSmSolid";
export default {
    name: "Incrementor",
    components: {IconPlusSmSolid, IconMinusSmSolid, IconMinusOutline},
    props: ['value', 'min', 'max', 'disabled'],
    
    methods: {
        dec() {
            if (this.value === this.min) {
                return;
            }
            this.$emit('input', this.value - 1);
        },
        inc() {
            console.log(this.max);
            if (this.disabled) {
                return;
            }
            if (this.max && this.value >= this.max) {
                return;
            }
            this.$emit('input', this.value + 1);
        }
    }
}
</script>

<style scoped>

</style>
